import { get } from 'idb-keyval'
import _, { isString } from 'lodash'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { isCategory, isMapstackProperty } from 'utils'
import { setBoundaryOptions } from '~map-preview/states/boundaries'
import {
  addDataset,
  setCategories,
  setJsonFeatures,
  useMap as useMapData
} from '~map-preview/states/map'
import { fetchAndStoreData } from '~map-preview/utils/fetchAndStoreData'

export const useGeojsonData = () => {
  const [geojson, setGeojson] = useState()
  const mapData = useMapData()
  const dispatch = useDispatch()

  useEffect(() => {
    const fetchData = async () => {
      const { dataId } = mapData
      let cachedGeojson = await get(dataId)

      if (!cachedGeojson) {
        cachedGeojson = await fetchAndStoreData(dataId)
      }

      setGeojson(cachedGeojson)

      dispatch(setJsonFeatures(cachedGeojson.features))
      dispatch(addDataset(dataId))

      const boundaries = _.get(cachedGeojson, ['ms_metadata', 'boundaries'], [])
      dispatch(setBoundaryOptions(boundaries))

      const categories = getCategories(cachedGeojson)
      dispatch(setCategories(categories))
    }

    mapData?.id && fetchData()

    return () => {}
  }, [mapData, dispatch])

  return geojson
}

function getCategories(geojson): Record<string, string[]> {
  const groupUnqiue = {}
  const valueCounts = {}

  for (const feature of geojson.features) {
    const { properties } = feature
    if (!properties) return groupUnqiue
    for (const [key, value] of Object.entries(properties)) {
      if (!isString(value)) continue // Skip non-string values
      if (isMapstackProperty(key)) continue // Skip mapstack properties MS_* and id
      if (!groupUnqiue[key]) groupUnqiue[key] = new Set()
      if (!valueCounts[value]) valueCounts[value] = 0
      groupUnqiue[key].add(value)
      valueCounts[value]++
    }
  }

  const categories = {}

  // Pick categories by count
  for (const pair of Object.entries(groupUnqiue)) {
    const [key, values] = pair as [string, Set<string>]
    if (isCategory(values.size)) categories[key] = Array.from(values)
  }

  return categories
}
